import TableRow from "./tableRow";

interface DataTableProps {
  columns?: any;
  rows: Array<Array<string>>;
  onRowClick?: (row: any) => void;
}

const dataTable = (tabla: DataTableProps) => {
  return (
    <div className="cfamili_tabla">
      <div className="cfamilia_row is-header" style = {{gridTemplateColumns: "repeat(" + tabla.columns.length + ", 1fr)"}}>
        {tabla.columns.map((column: { key: string; label: string }) => (
          <div key={column.key} className="cfamilia_boxbold">
            <div className="text-block">{column.label}</div>
          </div>
        ))}
      </div>
      {tabla.rows.map((row: any, index: number) => (
        <div key={index} className="cfamilia_row" style = {{gridTemplateColumns: "repeat(" + tabla.columns.length + ", 1fr)"}}>
          <TableRow
            key={index}
            columns={tabla.columns}
            row={row}
            onRowClick={() => tabla.onRowClick && tabla.onRowClick(row)}
          />
        </div>
      ))}
    </div>
  );
};
export default dataTable;
